import { useState, Suspense, lazy } from "react";
import "./App.css";
import Menu from "./components/Menu/menu.js";
import Footer from "./pages/Footer/footer.js";

const Home = lazy(() => import("./pages/Home/home.js"));
const About = lazy(() => import("./pages/About/about.js"));
const Skills = lazy(() => import("./pages/Skills/skills.js"));
const Contacts = lazy(() => import("./pages/Contacts/contacts.js"));
const Portfolio = lazy(() => import("./pages/Portfolio/portfolio.js"));
const Blog = lazy(() => import("./pages/Blog/blog.js"));

function App() {
  const [page, setPage] = useState("/");


  return (
    <div className="body">
      <Menu onSelect={setPage} activePage={page} />

      <Suspense fallback={<div />}>
        {page === "/" && <Home />}
        {page === "about" && <About />}
        {page === "contacts" && <Contacts />}
        {page === "skills" && <Skills />}
        {page === "portfolio" && <Portfolio />}
        {page === "blog" && <Blog />}
      </Suspense>

      <Footer onSelect={setPage} activePage={page} />
    </div>
  );
}

export default App;

